import React from 'react';

import { BatchCardInner } from './BatchCardInner';
import type { BatchCardProps } from './BatchCard.types';

export type { BatchCardProps };

export function BatchCard(props: BatchCardProps) {
    return <BatchCardInner {...props} />;
}

export default BatchCard;
